import { axiosMock } from '@api/client';
import { API_URL } from '@api/apiDictionary';
import { faker } from '@faker-js/faker';
import { QCTaskComment } from '@restore/QCTaskComments/QCTaskComments.types';

export const randomQCTaskComment: (
  message?: string
) => QCTaskComment = message => ({
  created: faker.date.past().toISOString(),
  message: message ?? faker.lorem.sentence(),
  writer: faker.person.fullName(),
  writerFullName: faker.person.fullName(),
  id: faker.string.uuid(),
});

const generateResponse = (number: number) => {
  return new Array(number).fill(undefined).map(randomQCTaskComment);
};

export const fetchQCTaskCommentsMock = async (taskId: string) => {
  const data = generateResponse(faker.number.int({ min: 1, max: 50 }));
  axiosMock
    .onGet(API_URL.qcTaskComments.replace(':taskId', taskId))
    .reply(200, data);
  axiosMock.onGet(API_URL.qcTaskComments.replace(':taskId', taskId));
};

export const addQCTaskCommentsMock = async (
  taskId: string,
  message: string
) => {
  const data = randomQCTaskComment(message);
  axiosMock
    .onPost(API_URL.qcTaskComments.replace(':taskId', taskId))
    .reply(200, data);
  axiosMock.onPost(API_URL.qcTaskComments.replace(':taskId', taskId));
};
